import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selectBlueprint: {
		id: 'servicedesk.automation.summary.add-rule.blueprint-options.select-blueprint',
		defaultMessage: 'Or select a blueprint',
		description: 'Heading above a list of blueprints that can be selected.',
	},
});
